import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import {
    useForm,
    useFetch,
    useResource,
    useGrid,
    useModal,
    useStore,
    useToast,
    usePopup,
    usePage,
    useAuth,
} from "@/comn/hooks"; // hook
import { URLS, APIS, SG_BLL_RESD_LIST, SF_BLL_RESD_SRCH } from "./services/OsciBllRgService"; // 서비스
import dayjs from "dayjs";

/*
 * Bill Re-send Management
 * !== 고지 재전송 관리 ==!
 */
export const OSCI0406003Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const popup = usePopup(); // Popup Hook !== Popup Hook ==!
    const auth = useAuth();
    const [sendTpCd, setSendTpCd] = useState("A");

    useResource({
        defaultSchema: [
            { area: "coCd" },
            { area: "bnkCd" },
            { area: "cstmCd" },
            { area: "comnCd", comnCd: "OSC0075" },
            { area: "comnCd", comnCd: "OSC0076" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Bill Re-send Search Form !== 고지 재전송 검색 폼 ==!
        resdSrch: useForm({
            defaultSchema: SF_BLL_RESD_SRCH,
            defaultValues: {
                strtDt: comnUtils.getDate({ d: -7 }),
                endDt: comnUtils.getDate(),
                sendTpCd: "A",
                ntcTpCd: "A",
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Bill Re-send Data List Grid !== 고지 송신 목록 그리드 ==!
        bllResdList: useGrid({
            defaultSchema: SG_BLL_RESD_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Bill Re-send List !== 고지 재전송 목록 조회 ==!
        getBllResdList: useFetch({
            api: (page = grid.bllResdList.page) => {
                return APIS.getBllResdList(form.resdSrch.getValues(), page, grid.bllResdList.size);
            },
            enabled: comnUtils.isEmpty(form.resdSrch.errors) && form.resdSrch.isSubmitted && sendTpCd == "A",
            key: [grid.bllResdList.page, grid.bllResdList.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.resdSrch.getValues(),
                    page: grid.bllResdList.page,
                    size: grid.bllResdList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
        // RG Send !== RG 전송 ==!
        zmpSend: useFetch({
            api: (data) => APIS.zmpSend({ zanMalipoSendLst: [data] }),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00031", // Processed successfully.
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Re-send List !== 재전송 목록 조회 ==!
        getResdList: () => {
            form.resdSrch.handleSubmit(
                (data) => {
                    grid.bllResdList.setPage(0);
                    fetch.getBllResdList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        // RG Send !== RG 전송 ==!
        zmpSend: (data: any) => {
            modal.openModal({
                content: t("msg.osc.00047", { 0: "Bill" }), // Do you want to send Bill?
                onConfirm: () => {
                    fetch.zmpSend.fetch(data);
                },
                onCancel: () => {
                    return false;
                },
            });
        },
    };

    const render = {
        grid_bllResdList: {
            cell: {
                bllNo: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <span style={{ color: "blue" }}>
                            <Link
                                to=""
                                onClick={() => {
                                    let nBllMgmtId = `${rowValues.bllTpCd}-${rowValues.bllSysmCd}-${rowValues.bllYy}-${rowValues.bllSrno}-${rowValues.bllDgr}`;
                                    popupFunc.openBllPopup(nBllMgmtId); // 고지정보 조회 팝업
                                }}
                            >{`${rowValues.bllNo}`}</Link>
                        </span>
                    );
                },
                tansadNo: (props: any) => {
                    const { rowValues } = props;
                    return (
                        rowValues.reffKeyTpCd == "T" && (
                            <Link
                                to=""
                                onClick={() => {
                                    popupFunc.openTansadPopup(`${rowValues.tansadNo}`); // TANSAD정보 조회 팝업
                                }}
                            >{`${rowValues.tansadNo}`}</Link>
                        )
                    );
                },
                zmpSend: (props: any) => {
                    const { rowValues } = props;
                    if (form.resdSrch.getValue("ntcTpCd") == "R") {
                        rowValues.ntcTpCd = "R"; // Reuse Bill 전송시 ntcTpCd를 R로 설정
                    } else if (form.resdSrch.getValue("ntcTpCd") == "P") {
                        rowValues.ntcTpCd = "P"; // Payment Information Request 전송시 ntcTpCd를 P로 설정
                    }

                    return (
                        rowValues.bllStatCd != "C" && (
                            <Button
                                onClick={() => {
                                    handler.zmpSend(rowValues);
                                }}
                            >
                                {t("B_SEND")}
                            </Button>
                        )
                    );
                },
                txprTin: (props: any) => {
                    const { rowValues } = props;
                    return `[${rowValues.txprTin}] ${rowValues.txprNm}`;
                },
            },
        },
    };

    // 팝업 호출
    const popupFunc = {
        // 고지 팝업
        openBllPopup: (bllNo: any) => {
            popup.openPopup({
                url: `${URLS.osci0401002q}/${bllNo}`,
                size: "md",
                layout: "popup",
                callback: (data: any) => {},
            });
        },
        // TANSAD 팝업
        openTansadPopup: (tansadNo: any) => {
            popup.openPopup({
                url: `${URLS.osci0202002q}/${tansadNo}`,
                size: "md",
                layout: "popup",
                callback: (data: any) => {},
            });
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.getResdList();
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.resdSrch.schema.cstmOfceCd}></Group.Control>
                                <Group.Control {...form.resdSrch.schema.sendStts}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.resdSrch.schema.sendDt}></Group.Control>
                            </Group.Row>
                            {sendTpCd == "A" && (
                                <>
                                    <Group.Row>
                                        <Group.Label label={"L_BLL_NO"} />
                                        <Group.Col>
                                            {/* 고지번호 */}
                                            <Group.Control
                                                {...form.resdSrch.schema.bllTpCd}
                                                onPaste={(e: any) => {
                                                    e.preventDefault();
                                                    const data = e.clipboardData.getData("Text").replaceAll("-", "");

                                                    form.resdSrch.setValue("bllTpCd", data.substring(0, 1));
                                                    form.resdSrch.setValue("bllSysmCd", data.substring(1, 5));
                                                    form.resdSrch.setValue("bllYy", data.substring(5, 7));
                                                    form.resdSrch.setValue("bllSrno", data.substring(7, 14));
                                                    form.resdSrch.setValue("bllDgr", data.substring(14, 15));
                                                }}
                                            />
                                            <Group.Any>-</Group.Any>
                                            <Group.Control {...form.resdSrch.schema.bllSysmCd} />
                                            <Group.Any>-</Group.Any>
                                            <Group.Control {...form.resdSrch.schema.bllYy} />
                                            <Group.Any>-</Group.Any>
                                            <Group.Control {...form.resdSrch.schema.bllSrno} />
                                            <Group.Any>-</Group.Any>
                                            <Group.Control {...form.resdSrch.schema.bllDgr} />
                                        </Group.Col>

                                        <Group.Label label={"L_TANSAD_NO"} />
                                        <Group.Col>
                                            {/* TANSAD번호 */}
                                            <Group.Control
                                                {...form.resdSrch.schema.tansadCstmOfceCd}
                                                onPaste={(e: any) => {
                                                    e.preventDefault();
                                                    const data = e.clipboardData.getData("Text").replaceAll("-", "");

                                                    form.resdSrch.setValue("tansadCstmOfceCd", data.substring(0, 4));
                                                    form.resdSrch.setValue("tansadYy", data.substring(4, 6));
                                                    form.resdSrch.setValue("tansadSrno", data.substring(6, 13));
                                                }}
                                            ></Group.Control>
                                            <Group.Any>-</Group.Any>
                                            <Group.Control {...form.resdSrch.schema.tansadYy}></Group.Control>
                                            <Group.Any>-</Group.Any>
                                            <Group.Control {...form.resdSrch.schema.tansadSrno}></Group.Control>
                                        </Group.Col>
                                    </Group.Row>
                                    <Group.Row>
                                        <Group.Control {...form.resdSrch.schema.ntcTpCd}></Group.Control>
                                    </Group.Row>
                                </>
                            )}
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.resdSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getResdList();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Button
                        role="excelDown"
                        onClick={() => {
                            const tgGrid = grid.bllResdList;

                            tgGrid.exportExcel({
                                /* 다운로드 엑셀 파일명 (확장자 없이), 기본값 Export(년월일시분초) */
                                excelName: dayjs().format("YYYY-MM-DD HH:mm:ss") + "_" + pgeUid,

                                /* 다운로드 엑셀 시트명 , 기본값 Sheet */
                                sheetName: "Sheet Name",
                            });
                        }}
                    ></Button>
                    <Group.Section>
                        <Grid
                            {...grid.bllResdList.grid}
                            data={fetch.getBllResdList.data?.bllResdList}
                            render={render.grid_bllResdList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
